import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { API_URL_CURRENT_FRAGMENT } from "@insite/client-framework/Services/ApiService";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";

replaceInChain(chain, PopulateApiParameter, props => {
    const pageType = getCurrentPage(props.getState()).type;
    const cartSettings = props.getState().context.settings.settingsCollection.cartSettings;

    props.apiParameter = {
        cartId: API_URL_CURRENT_FRAGMENT,
        expand: ["shipping", "cartLines"],
    };

    if (!getSession(props.getState()).rememberMe) {
        props.apiParameter.expand?.push("validation");
    }

    if (props.needFullCart) {
        props.apiParameter.forceRecalculation = true;
        props.apiParameter.allowInvalidAddress = true;
        props.apiParameter.expand = [
            ...(props.apiParameter.expand || []),
            "cartLines",
            "restrictions",
            "tax",
            "carriers",
            "paymentOptions",
            "costCodes",
        ];

        if (pageType === "CartPage") {
            props.apiParameter.expand.push("hiddenproducts");
        }
        if (cartSettings.showTaxAndShipping || pageType !== "CartPage") {
            props.apiParameter.expand.push("tax");
        }
    }

    if (props.parameter.getCartLines) {
        props.apiParameter.expand?.push("cartLines");
    }

    if (props.parameter.getCostCodes) {
        props.apiParameter.expand?.push("costCodes");
    }
});